import { render, staticRenderFns } from "./UserSettingsView.vue?vue&type=template&id=482555f0&"
import script from "./UserSettingsView.vue?vue&type=script&lang=js&"
export * from "./UserSettingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports